// @flow
import styled from 'styled-components';
import SVGIcon from '~/core/icons/svg-icons';

const size = 3;

export const Main = styled.div`
    display: flex;
    justify-content: space-between;
    margin-right: ${size / 2}em;
    position: relative;
    width: ${p => size * (p.number + (p.number - 1) / 3)}em;
`;

export const Line = styled.hr`
    border-top-color: ${p => (p.disabled ? p.theme.secondaryMedium : p.theme.mainBrandColor)};
    left: ${size / 2}em;
    margin: 0;
    position: absolute;
    top: 50%;
    width: calc(100% - ${size}em);
`;

export const IconContainer = styled.div`
    align-items: center;
    background-color: ${p => p.theme.white};
    border: ${p => (p.disabled ? 'dashed' : 'solid')} 1px ${p => p.theme.secondaryMedium};
    border-radius: 100%;
    display: flex;
    height: ${size}em;
    justify-content: center;
    position: relative;
    width: ${size}em;

    & > svg > g {
        fill: ${p => (p.disabled ? p.theme.secondaryHeavy : 'inherit')};
    }
`;

export const Icon = styled(SVGIcon)`
    height: ${size * 0.7}em;
    position: relative;
    width: ${size * 0.7}em;
`;

export const NumberContainer = styled.div`
    align-items: center;
    background-color: ${p => p.theme.white};
    display: flex;
    height: 1em;
    justify-content: center;
    left: calc(${size * 5 / 6}em - 2px);
    position: absolute;
    width: ${size / 3}em;
`;

export const Number = styled.div`font-size: 0.625em;`;



// WEBPACK FOOTER //
// ./src/components/widgets/actions/icons-summary/styles.js